import { useEffect } from 'react';

/**
 * Sets how the page prints, for as long as the component using it is on
 * screen: an `@page` rule is added to the document and taken away again.
 *
 * `@page` cannot be scoped to one part of an app, so it must not live in the
 * stylesheet every page shares; there it would change how all of them print.
 * It is a hook of its own, rather than a <style> in the page, because jsdom
 * cannot parse `@page` and any test that rendered it would fail on the first
 * query that reads a computed style.
 */
export function usePrintPage(rule: string) {
  useEffect(() => {
    const style = document.createElement('style');
    style.dataset.printPage = '';
    style.textContent = `@page { ${rule} }`;
    document.head.appendChild(style);
    return () => style.remove();
  }, [rule]);
}
